module.exports = __webpack_public_path__ + "img/bg_8.69a57b2b.png";